import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class MegaMenuImageBlock extends Component {
  static propTypes = {
    title: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string.isRequired,
    classStyle: PropTypes.string,
    imagesBlock: PropTypes.object,
    imageTitle: PropTypes.string,
    imageSubTitle: PropTypes.string,
    link: PropTypes.string,
  }

  static defaultProps = {
    title: null,
    alt: null,
    url: null,
    classStyle: null,
    imagesBlock: null,
    imageTitle: null,
    imageSubTitle: null,
    link: null,
  }
  onClick= (e)=> {
    const {
      link,
    } = this.props

    if(link) {
      window.location.href = link
    }else{
      return false
    }
  }

  render() {
    const {
      title,
      alt,
      url,
      imageTitle,
      imageSubTitle,
      link,
    } = this.props

    return (
      <React.Fragment>
        <a className="megamenu__image" onClick={this.onClick} href={link}>
          <img
            src={url}
            width="220"
            height="220"
            alt={alt}
            title={title}
          />
          <div className="megamenu__image-subtitle">{imageSubTitle}</div>
          <div className="megamenu__image-title" dangerouslySetInnerHTML={{__html: imageTitle}}/>
        </a>
      </React.Fragment>
    )
  }
}
